export default __webpack_public_path__ + "static/media/background-login.7df1e190.png";